export default [
    require('./epsg28992').default
]